import React, { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Container, Row, Col, Button, Label, Spinner } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IntrovideoUpdate from './IntroVideo-update';
import { deleteEntity, updateEntity, getEntity, getEntityProfileDetails } from 'app/entities/user-profile/user-profile.reducer';

const Introvideo: React.FC = () => {
  const account = useAppSelector(state => state.authentication.account);
  const [selectedIntroVideoId, setSelectedIntroVideoId] = useState(null);
  const [userProfiledata, setUserProfiledata] = useState(null);
  const loading = useAppSelector(state => state.userProfile.loading);
  const [showView, setShowView] = useState('list');
  const baseImageUrl = '/image';
  const userProfiledataList = useAppSelector(state => state.userProfile.entity);
  const dispatch = useAppDispatch();
  const id = account.id;
  const navigate = useNavigate();
  const [videoUrl, setVideoUrl] = useState<string | null>(null);
  const [videoLoading, setVideoLoading] = useState(false);

  useEffect(() => {
    // console.log(userProfiledataList, 'user profile data');
    // Extract the actual user profile data from the object structure
    if (userProfiledataList && userProfiledataList['0']) {
      setUserProfiledata(userProfiledataList['0']);
    } else {
      setUserProfiledata(userProfiledataList);
    }
  }, [userProfiledataList]);

  const handleSubmit = () => {
    // Refresh the user profile data after update

    dispatch(getEntityProfileDetails(account.id));
    setShowView('list');
  };
  const getVideoUrl = async (fileId: string) => {
    if (!fileId) return null;
    const requestUrl = `/downloadIntroductionVideo?fileId=${fileId}`;
    try {
      const response = await axios.get(requestUrl, { responseType: 'blob' });
      // Directly use the blob from response.data
      return URL.createObjectURL(response.data);
    } catch (error) {
      console.error('Error fetching video blob:', error);
      return null;
    }
  };

  useEffect(() => {
    if (userProfiledata?.introductionVideoFileId) {
      const fileId = userProfiledata?.introductionVideoFileId?.replace(/\.[^/.]+$/, '');
      const fetchVideoUrl = async () => {
        setVideoLoading(true); // Start loader
        try {
          // const url = await getVideoUrl(userProfiledata.introductionVideoFileId);
          const url = await getVideoUrl(fileId);

          setVideoUrl(url);
        } catch (error) {
          console.error('Error fetching video URL', error);
        } finally {
          setVideoLoading(false); // Stop loader
        }
      };
      fetchVideoUrl();
    }
  }, [userProfiledata]);
  function formatDate(dateString) {
    if (!dateString) return '';

    const inputDate = new Date(dateString);
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    if (inputDate >= currentDate) {
      const options = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      };

      return 'Today ' + inputDate.toLocaleTimeString('en-US', options as Intl.DateTimeFormatOptions);
    } else {
      const oneDayAgo = new Date(inputDate);
      oneDayAgo.setUTCDate(inputDate.getUTCDate() - 1);

      const options = {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      };

      return oneDayAgo.toLocaleString('en-US', options as Intl.DateTimeFormatOptions);
    }
  }

  // Check if user has an intro video
  const hasIntroVideo = userProfiledata?.introductionVideoFileId ?? userProfiledata?.introductionVideoLink;

  return (
    <Container className="intro-video-page card meeting-border">
      {showView === 'edit' && <IntrovideoUpdate userId={selectedIntroVideoId} handleSubmit={handleSubmit} />}
      {showView === 'add' && <IntrovideoUpdate userId={selectedIntroVideoId} handleSubmit={handleSubmit} />}
      {loading ? (
        <Spinner className="body-loader-icon"></Spinner>
      ) : (
        <>
          {showView != 'add' && showView != 'edit' && (
            <div className="intro-video-card">
              <Row className="page-header">
                <Col md="6" className="heading">
                  <h1>Personal Video</h1>
                </Col>
                <Col md="6" className="add-btn">
                  {/* {showView !== 'add' && !hasIntroVideo && (
                    <div className="intro-video-add-btn">
                      <FontAwesomeIcon icon="plus" />
                      &nbsp;
                      <Label
                        className="add-new-btn"
                        onClick={() => {
                          setShowView('add');
                          setSelectedIntroVideoId(null);
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                      >
                        Add Personal Intro Video
                      </Label>
                    </div>
                  )} */}
                </Col>
              </Row>
              <Row className="intro-video-list">
                {account ? (
                  hasIntroVideo ? (
                    <Col md="12">
                      <div className="intro-video-item">
                        <div className="intro-video-title">
                          <h3>Video Title</h3>
                          <p>{userProfiledata.videoTitle || 'Untitled Video'}</p>
                        </div>
                        <div className="intro-video-description">
                          <h3>Video Description</h3>
                          <p>{userProfiledata.videoDescription || 'No description provided'}</p>
                        </div>
                        <div className="intro-video-description">
                          <h3>Personal Video Link </h3>
                          {/* <p>{userProfiledata.introductionVideoLink || 'No interview link provided'}</p> */}
                          {userProfiledata.introductionVideoLink ? (
                            <a href={userProfiledata.introductionVideoLink} target="_blank" rel="noopener noreferrer">
                              {userProfiledata.introductionVideoLink}
                            </a>
                          ) : (
                            <p>No Personal Video link provided</p>
                          )}
                        </div>

                        {videoLoading ? (
                          <Spinner className="body-loader-icon" />
                        ) : (
                          videoUrl && (
                            <video
                              key={videoUrl}
                              controls
                              className="mb-4 p-0"
                              style={{ maxWidth: '100%', maxHeight: '400px' }}
                              src={videoUrl}
                            >
                              Your browser does not support the video tag.
                            </video>
                          )
                        )}

                        <Row className="intro-video-actions">
                          <Col md="8">
                            {userProfiledata.user?.lastModifiedDate && (
                              <div className="intro-video-time">Last updated: {formatDate(userProfiledata.user.lastModifiedDate)}</div>
                            )}
                          </Col>
                          <Col md="4" className="edit-btn">
                            <Button
                              onClick={() => {
                                setShowView('edit');
                                setSelectedIntroVideoId(userProfiledata?.user?.id);
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                              }}
                              color="primary"
                              size="sm"
                              data-cy="entityEditButton"
                            >
                              <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  ) : (
                    <div className="no-intro-video">
                      <Row>
                        <div className="col-md-6">
                          <h4>Add Your Personal Introduction Video</h4>
                          <p>
                            Create a personal introduction video to help others get to know you better. A short video introduction can make
                            your profile more engaging and help you connect with like-minded professionals in your industry.
                          </p>
                          <Button
                            color="primary"
                            onClick={() => {
                              setShowView('add');
                              setSelectedIntroVideoId(null);
                            }}
                          >
                            <FontAwesomeIcon icon="plus" /> Add Intro Video
                          </Button>
                        </div>
                        <div className="col-md-6">
                          <img src="content/images/meeting-tab.gif" alt="Intro Video Placeholder" style={{ maxWidth: '100%' }} />
                        </div>
                      </Row>
                    </div>
                  )
                ) : (
                  <Spinner color="primary" />
                )}
              </Row>
            </div>
          )}
        </>
      )}
    </Container>
  );
};

export default Introvideo;
